import { render } from "./NormvaluesExport.vue?vue&type=template&id=a12d7488&scoped=true"
import script from "./NormvaluesExport.vue?vue&type=script&lang=js"
export * from "./NormvaluesExport.vue?vue&type=script&lang=js"

import "./NormvaluesExport.vue?vue&type=style&index=0&id=a12d7488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12d7488"]])

export default __exports__